module.exports = __webpack_public_path__ + "media/images/homes/Vendorpurchaseorders-7f60ba69995dbfe81ba6cb4745e694d1.png";